"use client";

import HlsVideoPlayer from "@/components/common/HlsVideoPlayer";

/**
 * Publitio VSL player for the ported WordPress marketing pages.
 *
 * The original pages embedded Publitio via the `[publitio]player|<id>|PlayerV1`
 * shortcode. Publitio serves every file as an HLS stream at
 * `https://media.publit.io/file/<id>.m3u8`, so we reuse the app's HlsVideoPlayer
 * with that direct source (same approach as the Elite page's EliteHeroVideo).
 */
export function PublitioHlsVideo({
  mediaId,
  poster,
  className,
}: {
  mediaId: string;
  poster?: string;
  className?: string;
}) {
  return (
    <HlsVideoPlayer
      src={`https://media.publit.io/file/${mediaId}.m3u8`}
      poster={poster}
      className={className}
    />
  );
}
